<template>
  <div class="file-card">
    <a :href="text" download="file">
      <slot>{{ fileName }}</slot>
    </a>
    <span class="text-2">{{ fileSizeFormatted }}</span>
    <span v-if="parseInt(duration) > 0">{{ fileDurationFormatted }}</span>
  </div>
</template>

<script lang="ts">
import { computed, defineComponent } from "vue";

export default defineComponent({
  name: "FileCard",
  props: {
    fileSize: {
      type: String,
      default: "0",
    },
    duration: {
      type: String,
      default: "0",
    },
    text: {
      type: String,
      default: "",
    },
    fileName: {
      type: String,
      default: "",
    },
  },
  setup(props) {
    const formatFileSize = (bytes: number): string => {
      if (bytes === 0) return "0 B";

      const k = 1024;
      const sizes = ["B", "KB", "MB", "GB", "TB"];
      const i = Math.floor(Math.log(bytes) / Math.log(k));

      return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + " " + sizes[i];
    };

    const formatDuration = (seconds: number): string => {
      if (!seconds || seconds <= 0) return "00:00";

      const hours = Math.floor(seconds / 3600);
      const minutes = Math.floor((seconds % 3600) / 60);
      const secs = Math.floor(seconds % 60);

      if (hours > 0) {
        return `${hours.toString().padStart(2, "0")}:${minutes.toString().padStart(2, "0")}:${secs.toString().padStart(2, "0")}`;
      }

      return `${minutes.toString().padStart(2, "0")}:${secs.toString().padStart(2, "0")}`;
    };

    const fileSizeFormatted = computed(() =>
      formatFileSize(Number(props.fileSize)),
    );

    const fileDurationFormatted = computed(() =>
      formatDuration(Number(props.duration)),
    );

    return { fileSizeFormatted, fileDurationFormatted };
  },
});
</script>

<style lang="less" scoped>
.file-card {
  display: flex;
  flex-direction: column;
  gap: 4px;
  a {
    text-decoration: underline;
    word-break: break-all;
  }
}
</style>
